import { CountryCode, ProductCodeKey } from '@dayetopia/library';
import { HSA_FSA_COUNTRIES } from '@constants';
import { isFlexPayEnabled } from '@utils/environment';
import { getProductPricesFromStorage } from '@utils/prices';

export function isHsaFsaAvailable(country: CountryCode, productCode?: ProductCodeKey) {
  const showFlexPay = isFlexPayEnabled();
  const pricesData = getProductPricesFromStorage();

  if (!showFlexPay || !HSA_FSA_COUNTRIES.includes(country)) {
    return false;
  }

  if (productCode) {
    const hsaFsaEligibleProducts = pricesData.filter((product) => product.isHsaFsaEligible).map((product) => product.id);

    if (!hsaFsaEligibleProducts.includes(productCode)) {
      return false;
    }
  }

  return true;
}
